import {
  Box,
  Button,
  Divider,
  Grid,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import useInputObject from "../../hooks/useInputObject";
import { getContainerShipping } from "../../http/api/ContainerAPI";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import { useEffect, useState } from "react";
import { getHyphenedDate } from "../../utils/utils";

//ショットカット展開
const ROW_COLUMN_COUNT = 3;
function handleKeyPress(event, submitContainer) {
  if (event.key === "Enter") {
    //Right Enter. TODO : Use Right Enter
    if (event.location === 3) {
      event.preventDefault();
      focusNavigation(event.target, event.shiftKey);
    }
    //Left Enter, Open Modal
    else if (event.location === 0) {
      event.preventDefault();
      //Toroku
      submitContainer();
      moveToElement(0);
    }
  }
}

function focusNavigation(currentElement, isPrevious = false) {
  const focusing = currentElement.id;
  const step = isPrevious ? -1 : 1;
  const currentRow = parseInt(focusing.split("-")[1], 10);
  let nextRow = currentRow + step;
  if (nextRow >= ROW_COLUMN_COUNT) nextRow = 0;
  moveToElement(nextRow);
}

function moveToElement(row = 0) {
  setTimeout(() => {
    const id = `container-${row}`;
    const element = document.getElementById(id);
    if (element) {
      element.focus();
    } else {
      console.log("Cannot find next element");
      console.log(`container-${row}`);
    }
  }, 0);
}
const emptyContainer = {
  containerShippedAt: getHyphenedDate(),
  buyerNo: "",
  buyerName: "",
  quantity: 0,
  rentingQuantity: 0,
  createdId: 1, //TODO JWT 追加した後削除
  updatedId: 1, //TODO JWT 追加した後削除
};

const ContainerForm = (props) => {
  const { buyers } = props;
  const container = useInputObject(emptyContainer);
  const [buyer, setBuyer] = useState();

  function handleSubmitContainer() {
    props.submitContainer(container.Value);
    container.setValue(emptyContainer);
    setBuyer(null);
  }
  useEffect(() => {
    if (buyer) {
      getRentingQuantity(buyer);
    } else {
      container.update("buyerNo", "");
    }
  }, [buyer]);

  async function getRentingQuantity(buyer) {
    try {
      //TODO : optimize performance
      const response = await getContainerShipping({
        buyerNo: buyer?.buyerNo,
      });
      // console.log(response);
      container.updates({
        buyerNo: buyer.buyerNo,
        buyerName: buyer.buyerName,
        rentingQuantity:
          response.listContainerShippingInfo[0].rentingQuantity || 0,
      });
    } catch {
      container.updates({
        buyerNo: buyer.buyerNo,
        buyerName: buyer.buyerName,
        rentingQuantity: 0,
      });
    }
  }

  return (
    <Box
      onKeyPress={(e) => handleKeyPress(e, handleSubmitContainer)}
      onFocus={(e) => e.target.select()}
    >
      <Typography variant="h6" textAlign="left" mb={3}>
        コンテナ数入庫エントリ
      </Typography>
      <Grid item xs="auto" display="flex" alignItems="center" sx={{ p: 0 }}>
        <Typography sx={{ width: 100 }}>日付</Typography>
        <TextField
          onChange={(e) =>
            container.update("containerShippedAt", e.target.value)
          }
          value={container.Value.containerShippedAt}
          sx={{ width: 500 }}
          type="date"
          id="container-0"
          InputProps={{
            paddingInline: 0,
            inputProps: {
              min: "1000-01-01",
              max: "9999-12-31",
            },
            ...props.InputProps,
          }}
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>得意先</Typography>
        {/* <OutlinedInput
          onChange={(e) => container.update("buyerNo", e.target.value)}
          value={container.Value.buyerNo}
          sx={{ width: 500 }}
          type="number"
          id="container-1"
          onBlur={handleBlurBuyerNo}
        /> */}
        <CommonAutocomplete
          id="container-1"
          value={buyer || null}
          onSelect={(e, newValue) => {
            setBuyer(newValue);
            focusNavigation(document.activeElement, false);
          }}
          name="buyerNo"
          data={buyers}
          filterOptions={(options, { inputValue }) => {
            inputValue = inputValue.trim();
            return options.filter((x) => {
              return (
                x.buyerNo.toString().startsWith(inputValue) ||
                x.buyerName.includes(inputValue)
              );
            });
          }}
          optionLabel={(option) =>
            option ? option.buyerNo + " - " + option.buyerName : ""
          }
          width={500}
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>前日在庫数</Typography>
        <OutlinedInput
          //   onChange={(e) => container.update("remain", e.target.value)}
          value={container.Value.rentingQuantity}
          sx={{ width: 500 }}
          type="number"
          disabled
          inputProps={{
            disableUnderline: true,
            style: {
              color: "black",
              backgroundColor: "white",
            },
          }}
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>コンテナ数</Typography>
        <OutlinedInput
          onChange={(e) => container.update("quantity", e.target.value)}
          value={container.Value.quantity}
          sx={{ width: 500 }}
          type="number"
          id="container-2"
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>差引</Typography>
        <OutlinedInput
          value={
            parseInt(container.Value.rentingQuantity) -
              parseInt(container.Value.quantity) >
            0
              ? parseInt(container.Value.rentingQuantity) -
                parseInt(container.Value.quantity)
              : 0
          }
          sx={{ width: 500 }}
          type="number"
          disabled
          inputProps={{
            disableUnderline: true,
            style: {
              color: "black",
              backgroundColor: "white",
            },
          }}
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Box display="flex" justifyContent="space-around">
        <Button
          variant="contained"
          color="error"
          mt={3}
          onClick={handleSubmitContainer}
        >
          追加
        </Button>
        <Button
          variant="outlined"
          color="primary"
          mt={3}
          onClick={props.closeModal}
        >
          戻る
        </Button>
      </Box>
    </Box>
  );
};

export default ContainerForm;
